module.exports = __webpack_public_path__ + "static/aereo-side-thumb-f49497c10123f4c4216d57e1eff8da11.jpg";